import axios from 'axios';

import { ApiServiceV1 } from '@services/api.service';

let cancelGetUsersNamesAutocomplete = () => {};
let cancelGetUsersEmailsAutocomplete = () => {};
const { CancelToken } = axios;

export default {
  async getUser({ id }) {
    const { data } = await ApiServiceV1.get(`user/${id}`);
    return data || {};
  },

  async getUsers({
    name = null, email = null, type = null,
    tenant = null, activeOnly = true, pageNum, pageSize = 10,
  }) {
    const { data } = await ApiServiceV1.get('user', {
      params: {
        name, email, type, tenant, locked: activeOnly ? false : null, pageNum, pageSize,
      },
    });
    return data.items || [];
  },

  async getUserHistory({ id, pageNum = 1, pageSize = 5 }) {
    const { data } = await ApiServiceV1.get(`user/${id}/history`, {
      params: {
        pageNum, pageSize,
      },
    });
    return data.items || [];
  },

  async getAzureTenant() {
    const { data } = await ApiServiceV1.get('tenant/all-azure');
    return data || [];
  },

  async getUsersNamesAutocomplete({ name }) {
    cancelGetUsersNamesAutocomplete();
    const { data } = await ApiServiceV1.get(`user/autocomplete/name/${name}`, {
      cancelToken: new CancelToken((c) => {
        cancelGetUsersNamesAutocomplete = c;
      }),
    });
    return data || [];
  },

  async getUsersEmailsAutocomplete({ email }) {
    cancelGetUsersEmailsAutocomplete();
    const { data } = await ApiServiceV1.get(`user/autocomplete/email/${email}`, {
      cancelToken: new CancelToken((c) => {
        cancelGetUsersEmailsAutocomplete = c;
      }),
    });
    return data || [];
  },

  createUser({ data }) {
    return ApiServiceV1.post('user', {
      name: data.name,
      email: data.email,
      password: data.password,
      barcode: data.barcode || null,
      tenant: data.tenant,
    });
  },

  updateUser({ id, data }) {
    return ApiServiceV1.put(`user/${id}`, {
      name: data.name,
      email: data.email,
    });
  },

  createdUserBarcode({ id, barcode, description }) {
    return ApiServiceV1.post(`user/${id}/barcode`, { barcode, description });
  },

  updateUserTenant({ id, tenant }) {
    return ApiServiceV1.put(`user/${id}/tenant`, { tenant });
  },

  changeUserPassword({ id, password }) {
    return ApiServiceV1.put(`user/${id}/password`, { password });
  },

  syncUsersWithAD({ authCode }) {
    return ApiServiceV1.post('user/sync', { authCode });
  },

  changeUserLockedState({ id, locked }) {
    return ApiServiceV1.put(`user/${id}/state`, { locked });
  },

  removeUserRole({ service, ...data }) {
    return ApiServiceV1.delete(`service/${service}/user`, { data });
  },

  removeUserBarcode({ id, barcode }) {
    return ApiServiceV1.delete(`user/${id}/barcode/${barcode}`);
  },

  cancelGetUsersNamesAutocomplete,
  cancelGetUsersEmailsAutocomplete,
};
